import { RefreshCw } from "lucide-react";
import Seo from "./Seo";
import NotFoundPage from "../pages/NotFoundPage";

export const BlogRequestState = ({ loading, error, retry }) => {
  if (loading) {
    return <div className="pt-32 pb-20 min-h-screen max-w-3xl mx-auto px-5" role="status" data-testid="blog-loading-state">
      <span className="sr-only">Loading article</span>
      <div className="h-10 bg-stone-200 animate-pulse mb-4" />
      <div className="h-72 bg-stone-200 animate-pulse" />
    </div>;
  }
  if (error === 404) return <NotFoundPage />;
  return <>
    <Seo title="Article Temporarily Unavailable | Texan Strong Builds"
      description="This article is temporarily unavailable. Please try again, or contact Texan Strong Builds for concrete and landscape advice in Austin, TX." noindex />
    <section className="pt-32 pb-24 max-w-3xl mx-auto px-5" role="alert" data-testid="blog-error-state">
      <h1 className="font-display text-4xl font-bold" data-testid="blog-error-title">We couldn’t load this article.</h1>
      <p className="mt-5 text-stone-600" data-testid="blog-error-message">Please try again in a moment.</p>
      <button className="btn-primary mt-8" onClick={retry} data-testid="blog-retry-button"><RefreshCw size={16} /> Try again</button>
    </section>
  </>;
};